module.exports = __webpack_public_path__ + "img/ecology7.b90fbaaf.png";